import { createAction } from 'redux-actions';

export const createOperation = createAction('CREATE_OPERATION');
export const createOperationSuccess = createAction('CREATE_OPERATION_SUCCESS');
export const createOperationFailure = createAction('CREATE_OPERATION_FAILURE');

export const updateOperation = createAction('UPDATE_OPERATION');
export const updateOperationSuccess = createAction('UPDATE_OPERATION_SUCCESS');
export const updateOperationFailure = createAction('UPDATE_OPERATION_FAILURE');

export const deleteOperation = createAction('DELETE_OPERATION');
export const deleteOperationSuccess = createAction('DELETE_OPERATION_SUCCESS');
export const deleteOperationFailure = createAction('DELETE_OPERATION_FAILURE');
